import {
    AfterContentInit,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Inject,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {AbstractControl, FormGroup, ValidationErrors} from '@angular/forms';

import {MatDialog} from '@angular/material/dialog';
import {MatDrawer} from '@angular/material/sidenav';
import {ActivatedRoute, Event, NavigationEnd, Params, Router} from '@angular/router';
import {BehaviorSubject, of, Subject} from 'rxjs';
import {catchError, filter, first, switchMap, takeUntil} from 'rxjs/operators';
import {
    FieldUiDataComboBoxObj,
    FieldValidationObj,
    ReportCellObj,
    ReportResponseObj,
    ReportRunParamsObj,
    ReportSearchResultObj,
    ReportUiDataObj,
    ReportUserConfigurationObj
} from '../../../../generated/generated-core.model';
import {DATE_FORMAT_DAY} from '../../../consts/date-time-format-consts';
import {
    MX_APPLICATION_PROPERTY_SERVICE_TOKEN,
    MxApplicationPropertiesService
} from '../../../shared/services/mx-application-property.service';
import {MX_REPORT_GENERATOR_TOKEN, MxGeneratorService} from '../../../shared/services/mx-generator.service';
import {MxButtonModel, MxButtonsConfig} from '../../mx-button/components/mx-button.model';
import {
    MxReportUrlDialogComponent,
    MxReportUrlDialogData
} from '../../mx-dialogs/components/mx-report-url-dialog/mx-report-url-dialog.component';
import {MxNotificationService} from '../../../shared/services/mx-notification.service';
import {MxUtilsService} from '../../../shared/services/mx-utils.service';
import {MxObjectFormComponent} from '../../mx-form/components/mx-object-form/mx-object-form.component';
import {
    FormMetaAndInitialData,
    MxFormCustomizerEvent,
    ObjectMetaData,
    ObjectMetaDataBuilder,
    OnBoFormReady
} from '../../mx-form/services/mx-form-fields-builder.service';
import {MxGridComponent} from '../../mx-grid/components/mx-grid/mx-grid.component';
import {GridColumn} from '../../mx-grid/services/grid-column';
import {MxFilterButtonModel, MxFilterButtonsConfig} from '../../mx-grid/services/mx-filter-button.model';
import {MxGridButtonModel, MxGridButtonsConfig} from '../../mx-grid/services/mx-grid-button.model';
import {
    MxGridCustomizerEvent,
    MxGridHandleOrderDefault,
    MxGridReload,
    MxGridService
} from '../../mx-grid/services/mx-grid-customizer-event';
import {DefaultGridButtons} from '../../mx-grid/services/mx-grid-enums';
import {MxRecentlyUsedService} from '../../mx-navigation-menu/services/mx-recently-used.service';
import {MxPreloaderService, PreloaderConfig, withPreloader} from '../../mx-preloader/services/mx-preloader.service';
import {MxReportFieldsConverterService} from '../services/mx-report-fields-converter.service';
import {MxReportViewCustomizerEvent, MxReportViewInputFilterDefault} from '../services/mx-report-view-customizer-event';
import {MxReportViewFilterActionsService} from '../services/mx-report-view-filter-actions.service';
import {EMPTY_VALUE_CONST, MxReportsDataService} from '../services/mx-reports-data.service';
import {MxCustomizable} from '../../../mx-customizer';
import {MxConfirmDialogComponent} from '../../mx-dialogs/components/mx-confirm-dialog/mx-confirm-dialog.component';

export class ReportFilters extends Array<{field: string, value?: any}> {
}

export const RUN_AFFILIATE_ID_PARAM = 'reportRunAffiliateId';
export const RUN_CAMPAIGN_ID_PARAM = 'reportRunCampaignId';
export const RUN_AS_AFFILIATE_PARAM = 'reportRunAsAffiliate';

@Component({
    selector: 'mx-report-view',
    standalone: false,
    templateUrl: './mx-report-view.component.html',
    styleUrls: ['./mx-report-view.component.scss'],
    providers: [
        MxReportViewFilterActionsService,
        MxReportsDataService
    ]
})
export class MxReportViewComponent implements OnInit, AfterContentInit,
    AfterViewInit, OnDestroy, MxGridReload, MxCustomizable<MxReportViewCustomizerEvent>, OnBoFormReady {
    private customColumns: Array<GridColumn>;

    public get filterButtonsTemplate(): TemplateRef<any> {
        return this.filterActionService.filterButtonsTemplate;
    }
    private useQueryParam: boolean = true;
    private reportName: string;
    private filterDefaults: MxReportViewInputFilterDefault[] = [];

    @ViewChild(MxGridComponent, {static: true})
    private grid: MxGridComponent;

    @ViewChild('drawer', {static: true})
    private drawer: MatDrawer;

    userConfigs: Array<UserConfig> = [];


    profileButton: MxButtonModel = {
        name: 'user-config',
        icon: 'settings_suggest',
        tooltip: 'User Configs',
        className: 'mxs-button--round mxs-button--primary mxs-button--primary-orange'
    };

    private filterForm: FormGroup;

    private filterFields: Array<ReportUiDataObj> = [];

    private outputExcludes: Set<string>;

    private fullFilterReset: boolean;


    private preloaderConfig: PreloaderConfig = {name: 'root', type: 'RoundSpinner'};

    @Output()
    customize: EventEmitter<MxReportViewCustomizerEvent> = new EventEmitter<MxReportViewCustomizerEvent>();

    @Output()
    requestParams: EventEmitter<ReportFilters> = new EventEmitter<ReportFilters>();

    @Output()
    reportViewChange: EventEmitter<ReportResponseObj> = new EventEmitter<ReportResponseObj>();

    private _fieldsData$$: BehaviorSubject<FormMetaAndInitialData>;

    reportView: ReportResponseObj;

    private gridService: MxGridService;

    public reportSearchResult: ReportSearchResultObj;

    private payLoad: any;

    private queryParams: Params;

    public isJobRunning: boolean = false;

    private initialFormValue: any = {};

    private _destroy$$: Subject<null> = new Subject<null>();

    private firstLoadReport: boolean = true;

    private isReloadNeeded: boolean = false;

    public filtersCollapsed: boolean = false;

    private reportRunParams: ReportRunParamsObj;

    private buttons: MxGridButtonsConfig = new MxGridButtonsConfig([
        [ DefaultGridButtons.filter, {
            hidden: false,
            clickHandler: () => {
                this.onFiltersToggle();
            }
        }],
        [ DefaultGridButtons.reload, {hidden: true}]
    ]);

    protected defaultFilterButtons: MxFilterButtonsConfig;
    public filterButtons: MxButtonsConfig;

    private coreReport: boolean = true;

    constructor(
        private preloader: MxPreloaderService,
        private filterActionService: MxReportViewFilterActionsService,
        private reportsDataService: MxReportsDataService,
        @Inject(MX_REPORT_GENERATOR_TOKEN) private generatorService: MxGeneratorService,
        private route: ActivatedRoute,
        private router: Router,
        private utils: MxUtilsService,
        private dialog: MatDialog,
        @Inject(MX_APPLICATION_PROPERTY_SERVICE_TOKEN) private applicationPropertiesService: MxApplicationPropertiesService,
        private notificationService: MxNotificationService,
        private converterService: MxReportFieldsConverterService,
        private recentlyUsed: MxRecentlyUsedService,
        private cdRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        if (this.route.snapshot.queryParams && this.route.snapshot.queryParams[RUN_AFFILIATE_ID_PARAM]) {
            this.reportRunParams = {
                affiliateId: this.route.snapshot.queryParams[RUN_AFFILIATE_ID_PARAM],
                campaignId: this.route.snapshot.queryParams[RUN_CAMPAIGN_ID_PARAM],
                asAffiliate: this.route.snapshot.queryParams[RUN_AS_AFFILIATE_PARAM]
            };

        }
        this.defaultFilterButtons = new MxFilterButtonsConfig([
            ['search', {
                type: 'submit',
                tooltip: 'Search',
                icon: 'search',
                permission: 'all',
                clickHandler: this.submitFilterForm,
                disabled: () => this.filterForm && this.filterForm.touched && this.filterForm.invalid,
                className: 'mxs-button--round mxs-button--primary'
            }],
            [
                'clear', {
                type: 'reset',
                tooltip: 'Reset filters',
                icon: 'clear',
                permission: 'all',
                clickHandler: this.resetFilterForm,
                className: 'mxs-button--round mxs-button--secondary'
            }],
            [
                'export', {
                type: 'button',
                tooltip: 'Export report',
                icon: 'get_app',
                permission: 'all',
                clickHandler: this.exportReport,
                disabled: () => this.filterForm && this.filterForm.touched && this.filterForm.invalid,
                className: 'mxs-button--round mxs-button--secondary'
            }],
            [
                'url', {
                type: 'button',
                tooltip: 'Report url',
                icon: 'public',
                permission: 'all',
                hidden: true,
                clickHandler: this.reportUrl,
                className: 'mxs-button--round mxs-button--secondary'
            }]
        ]);
        let buttonsConfig: MxButtonsConfig = new MxButtonsConfig();
        this.defaultFilterButtons.forEach((filterButtonModel: MxFilterButtonModel, name: string) => {
            buttonsConfig.set(name, MxFilterButtonsConfig.createButtonInput(filterButtonModel, this.clickHandler(filterButtonModel)));
        });
        this.filterButtons = buttonsConfig;
        this.router.events.pipe(
                takeUntil(this._destroy$$),
                filter((event: Event) => event instanceof NavigationEnd)
            )
            .subscribe(this.onRouteChanged);
        if (this.isNewTab()) {
            this.isReloadNeeded = true;
        }
    }


    ngAfterContentInit(): void {
        this.grid.customize.pipe(first()).subscribe((gridCustomizerEvent: MxGridCustomizerEvent) => {
            gridCustomizerEvent.customizeActions(this.buttons)
                .customizeGridReload(this)
                .customizeEmptyGridParams(() => {
                    if (this.firstLoadReport) {
                        return {image: 'ghost_smile', text: 'label.table.nodata.first'};
                    } else {
                        return {image: 'ghost_sad', text: 'label.table.nodata'};
                    }
                })
                .customizeProps({
                    dateFormat: DATE_FORMAT_DAY,
                })
                .customizeOrder(new MxGridHandleOrderDefault('order_col'));

            let reportViewCustomizerEvent: MxReportViewCustomizerEvent = new MxReportViewCustomizerEvent();
            reportViewCustomizerEvent.customizeReportName(this.route.snapshot.data.reportName);

            Object.assign(reportViewCustomizerEvent, gridCustomizerEvent);
            this.customize.emit(reportViewCustomizerEvent);
            if (reportViewCustomizerEvent.preloaderConfig) {
                this.preloaderConfig = {...this.preloaderConfig, ...reportViewCustomizerEvent.preloaderConfig};
            }
            this.fullFilterReset = reportViewCustomizerEvent.fullFilterReset;
            this.preloader.show(this.preloaderConfig);
            this.outputExcludes = new Set<string>(reportViewCustomizerEvent.outputExcludes);
            this.filterActionService.setUp(reportViewCustomizerEvent);
            this.reportName = reportViewCustomizerEvent.reportName;
            if (reportViewCustomizerEvent.columnsSource$) {
                reportViewCustomizerEvent.columnsSource$.pipe(first())
                    .subscribe(value => this.customColumns = value);
            }
            this.useQueryParam = reportViewCustomizerEvent.gridProps.useQueryParam;
            this.filterDefaults = reportViewCustomizerEvent.filterDefaults || this.filterDefaults;
            if (reportViewCustomizerEvent.loadRowsOnStart !== undefined) {
                this.coreReport = reportViewCustomizerEvent.isCoreReport;
            }
            if (!this.coreReport) {
                gridCustomizerEvent.customizeProps({
                    hideEmptyColumn: true
                });
            }
            let combinedActions = reportViewCustomizerEvent.filterButtons.reduce(
                (acc, curr) => this.combineFilterActions(acc, curr), this.defaultFilterButtons);
            let buttonsConfig: MxButtonsConfig = new MxButtonsConfig();
            combinedActions.forEach((filterButtonModel: MxFilterButtonModel, name: string) => {
                buttonsConfig.set(name, MxFilterButtonsConfig.createButtonInput(filterButtonModel, this.clickHandler(filterButtonModel)));
            });
            this.filterButtons = buttonsConfig;
            Object.assign(gridCustomizerEvent, reportViewCustomizerEvent);
            gridCustomizerEvent.onSetUp((service) => {
                this.gridService = service;
                this.getReportView();
                this.cdRef.detectChanges();
            });
            if (!gridCustomizerEvent.gridProps.gridId) {
                gridCustomizerEvent.customizeProps({
                    gridId: this.reportName ? this.reportName : this.reportDefId
                });
            }
            this.filtersCollapsed = reportViewCustomizerEvent.isFilterHidden;
        });

    }

    private clickHandler = (filterButtonModel: MxFilterButtonModel) => () => filterButtonModel.clickHandler(this.filterForm);

    private combineFilterActions(acc: MxFilterButtonsConfig, curr: MxFilterButtonsConfig): MxFilterButtonsConfig {
        curr.forEach((customOverride, key) => {
            acc.set(key, Object.assign(acc.get(key) || new MxGridButtonModel(), customOverride));
        });
        return acc;
    }

    ngAfterViewInit(): void {
        this.grid.sort.sortChange.pipe(
                takeUntil(this._destroy$$)
            )
            .subscribe(() =>  this.doReload());
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }

    doReload(): void {
        if (!this.reportView) {
            return;
        }
        this.preloader.hide(this.preloaderConfig);
        this.preloader.show(this.preloaderConfig, this.onPreloaderCancel);
        this.isJobRunning = true;
        let filterParams: ReportFilters = this.reportsDataService.getFilterParamsFromPayload(this.payLoad);
        this.requestParams.emit(filterParams);
        this.reportsDataService.getReportResults(this.reportName, filterParams,
            this.reportView.id, this.grid.sort.active, this.grid.sort.direction, this.reportRunParams)
            .subscribe({
                    next: (data) => {
                        if (data) {
                            this.reportSearchResult = data;
                            this.gridService.collection.setRows(this.generatorService.getGridLinesArray(data.cells));
                            let outColumn = this.reportView.output.filter(value => !this.outputExcludes.has(value.field));
                            this.gridService.columns.setColumns(
                                this.generatorService.getColumnsArray(outColumn, this.customColumns, this.reportName),
                                this.firstLoadReport);
                            this.gridService.grandTotals.setGrandTotals(this.getGrandTotals(this.reportSearchResult.totalsData));
                            this.getRowQueryParams();
                            this.showDataWarning();
                            this.firstLoadReport = false;
                        }
                    },
                    error: (error) => {
                        let errorMsg = this.notificationService.getErrorMessage(error);
                        this.notificationService.showFailure(errorMsg);
                    }
                }
            ).add(() => {
                this.isReloadNeeded = false;
                this.reportsDataService.runningJobId = null;
                this.isJobRunning = false;
                this.preloader.hide(this.preloaderConfig);
                if (this.coreReport) {
                    this.preloaderConfig.type = 'LinearSpinner';
                }
            });
    }

    onCustomizeFilters(boFormCustomizerEvent: MxFormCustomizerEvent): void {
        this._fieldsData$$ = boFormCustomizerEvent.fieldsData;
        boFormCustomizerEvent.customizeProps({showErrorMessage: false});
        boFormCustomizerEvent.addCustomizer(this);
    }


    private exportReport = (): void => {
        const oldFilters = this.reportsDataService.getFilterParamsFromPayload(this.payLoad);
        const newFilters = this.reportsDataService.getFilterParamsFromPayload(this.getFlattenPayload(false));
        let isAnyFilterSame = true;
        if (oldFilters.length !== 0) {
            isAnyFilterSame = oldFilters.length === newFilters.length ? newFilters.every((value, index) => value.value === oldFilters[index].value) : false;
        }
        of(isAnyFilterSame)
            .pipe(
                switchMap(isFilterSame => {
                    this.isJobRunning = true;
                    if (!isFilterSame) {
                        return this.dialog.open(MxConfirmDialogComponent, {
                            width: '40%',
                            panelClass: 'mx-dialog-panel-class',
                            data: {
                                type: 'warn',
                                title: 'Warning',
                                message: 'You have changed the values of filters without applying the search. ' + 'Be careful the values in the csv file may differ.'
                            }
                        }).afterClosed();
                    }
                    return of(isFilterSame);
                }),
                switchMap(isExportNeeded => {
                    if (isExportNeeded) {
                        const payload = isAnyFilterSame ? this.getPayload() : this.getFlattenPayload(false);
                        return this.reportsDataService.getExportedReport(
                            payload,
                            this.reportView.id,
                            this.reportView.name,
                            this.gridService.columns.visibleColumns,
                            this.reportRunParams
                        ).pipe(withPreloader(this.preloader));
                    }
                    return of(void 0);
                }),
                catchError((err, caught) => {
                    this.notificationService.showFailure('Error while exporting report');
                    return of(err);
                })).subscribe().add(() => this.isJobRunning = false);
    }

    private onRouteChanged = (): void => {
        if (!this.isJobRunning) {
            if (this.route.snapshot.params.id && this.route.snapshot.params.id !== this.reportView.id) {
                this.firstLoadReport = true;
                this.isReloadNeeded = true;
                this.gridService.storage.updateKey(this.route.snapshot.params.id);
                this.reportRunParams.affiliateId = this.route.snapshot.queryParams.reportRunAffiliateId;
                this.reportRunParams.campaignId = this.route.snapshot.queryParams.reportRunCampaignId;
                this.reportRunParams.asAffiliate = this.route.snapshot.queryParams.reportRunAsAffiliate;
                this.gridService.collection.setRows([]);
                this.getReportView();
            } else if (JSON.stringify(this.queryParams) !== JSON.stringify(this.route.snapshot.queryParams)) {
                this.queryParams = this.route.snapshot.queryParams;
                if (this.reportView) {
                    this.applyFilters(this.reportView.input);
                    this.submitFilterForm();
                }
            }
        }
    }

    private getReportView(): void {
        this.reportsDataService.getReportView(this.reportDefId, this.reportName, this.reportRunParams)
            .subscribe((reportView) => this.init(reportView));
    }

    private get reportDefId(): string {
        let id: string;
        if (this.route && this.route.snapshot && this.route.snapshot.params && this.route.snapshot.params.id) {
            id = parseInt(this.route.snapshot.params.id, 10).toString();
        }
        return id;
    }

    private init(reportView: ReportResponseObj): void {
        this.reportViewChange.emit(reportView);
        let filters = reportView.input;
        // TODO It looks like it works incorrect
        this.filterFields = filters.filter(field => field.filter);

        this.reportView = reportView;
        this.queryParams = this.route.snapshot.queryParams;
        this.gridService.collection.setSelected([]);
        this.gridService.columns.setColumns(
            this.generatorService.getColumnsArray(this.reportView.output, this.customColumns, this.reportName), true);
        this.loadReportUserConfig(reportView.name);
        this._fieldsData$$.next({
            objectMetaSource: {
                fieldsData: this.applyFilters(filters)
                    .map(value => this.converterService.convertToUiData(value))
            },
            initialData: {...this.getParams()}
        });
    }

    private getParams(): any {
        let queryParams = this.getQueryParams();
        if (Object.keys(queryParams).length > 0) {
            return queryParams;
        } else {
            return this.getSessionParams();
        }

    }

    private getQueryParams(): any  {
        if (!this.useQueryParam) {
            return {};
        }
        let queryParams = {...this.route.snapshot.queryParams};
        this.reportRunParams = {
            affiliateId: queryParams[RUN_AFFILIATE_ID_PARAM],
            campaignId: queryParams[RUN_CAMPAIGN_ID_PARAM],
            asAffiliate: queryParams[RUN_AS_AFFILIATE_PARAM]
        };
        delete queryParams[RUN_AFFILIATE_ID_PARAM];
        delete queryParams[RUN_CAMPAIGN_ID_PARAM];
        delete queryParams[RUN_AS_AFFILIATE_PARAM];
        return queryParams;
    }

    private getSessionParams(): any {
        return this.gridService.storage.getFilterData();
    }

    private getGrandTotals(totalsData: {[index: string]: ReportCellObj}): ReadonlyMap<string, number | string> {
        let grandTotals: Map<string, number | string> = new Map();

        if (totalsData) {
            for (let column of this.gridService.columns.columns) {
                let colName = column.prop;
                if (column.createSummary && totalsData[colName] && !isNaN(totalsData[colName].value)) {
                    grandTotals.set(column.prop, totalsData[colName].value);
                }
            }
        }

        return grandTotals;
    }

    private showDataWarning(): void {
        if (this.reportSearchResult.partialResult) {
            this.notificationService.showSuccess('The report returned too many rows, to see all results please use export', false);
        }
    }

    private getRowQueryParams(): void {
        this.gridService.props.setRowQueryParams(this.generatorService.getGridLinesQueryParamsArray(
                this.gridService.collection.rows, this.payLoad, this.gridService.columns.columns,
            this.grid.sort.active, this.grid.sort.direction));
    }

    private applyFilters = (filterArray: Array<ReportUiDataObj>): Array<ReportUiDataObj> => {
        filterArray.slice().forEach(filterItem => {
            let idx =  this.filterDefaults.findIndex(field => field.field === filterItem.field);
            if (idx !== -1) {
                Object.assign(filterItem, this.filterDefaults[idx]);
            }
            if (filterItem.sublist) {
                this.applyFilters(filterItem.sublist);
            }
        });
        return filterArray;
    }

    public submitFilterForm = () => {
        this.markInvalidFilters();
        if (this.reportView && !this.filterForm.invalid) {
            this.getPayload();
            if (!this.grid.propsService.props.showItemDetailsInDialog || !this.firstLoadReport) {
                this.doReload();
            }
        } else {
            this.preloader.hide(this.preloaderConfig);
        }
    }

    private markInvalidFilters(): void {
        Object.values(this.filterForm.controls).forEach(value => {
            if (value.invalid) {
                value.markAsTouched();
            }
        });
    }

    public resetFilterForm = (): void => {
        let disabledFields = {};
        Object.entries(this.filterForm.controls).forEach(([key, value]) => {
          if (value.disabled && value.value) {
              disabledFields[key] = value.value;
          }
        });
        this.filterForm.reset();
        this.filterForm.patchValue(disabledFields);
        this.markInvalidFilters();
        if (!this.fullFilterReset) {
            this.filterForm.patchValue(this.initialFormValue);
            let filterParams: ReportFilters = this.reportsDataService.getFilterParamsFromPayload(this.getPayload());
            this.requestParams.emit(filterParams);
        } else {
            this.requestParams.emit([]);
        }
    }

    private onPreloaderCancel = (): void => {

        // do nothing, if report was already canceled
        if (this.reportsDataService.runningJobId === -1) {
            return;
        }
        // if report was canceled before job have been started we set fake job id to prevent getting real report results
        if (this.reportsDataService.runningJobId === null) {
            this.reportsDataService.runningJobId = -1;
            return;
        }
        this.reportsDataService.cancelRunningJob().subscribe(
                (response: string) => {
                    if (response === 'CANCELED') {
                        this.notificationService.showSuccess('Your action was canceled.');
                    } else {
                        this.notificationService.showFailure('Status: ' + response);
                    }
                },
                (error) => {
                    let errorMsg = this.notificationService.getErrorMessage(error);
                    this.notificationService.showFailure(errorMsg);
                }
            ).add(() => {
                this.isJobRunning = false;
                this.preloader.hide(this.preloaderConfig);
                if (this.coreReport) {
                    this.preloaderConfig.type = 'LinearSpinner';
                }
            });
    }

    public getPayload(saveFilter: boolean = true): any {
        this.payLoad = this.getFlattenPayload(saveFilter);
        return this.payLoad;
    }

    public getFlattenPayload(saveFilter: boolean = true): any {
        let payload: any = this.filterForm.getRawValue();
        const inputs: Array<ReportUiDataObj> = this.getFlatInputs(this.reportView.input);
        payload = this.utils.convertPayloadDatesToTimestampsWithFormat(payload, inputs);
        this.removeDateRangeFields(payload, inputs);
        if (saveFilter) {
            this.saveFilter(payload, inputs);
        }
        payload = this.utils.flattenObject(payload);
        return payload;
    }

    saveFilter(filterValue: any, inputs: Array<ReportUiDataObj>): void {
        inputs.filter(value => value.value && value.type !== 'dateRange' && !value.field.endsWith('_list'))
            .forEach(value => {
                if (!filterValue[value.field]) {
                    filterValue[value.field] = EMPTY_VALUE_CONST;
                }
            });
        let skippedFilters = inputs.filter(value => value.hidden === true || value.disabled === true).map(value => value.field);
        const params = Object.keys(filterValue)
            .filter(key => !skippedFilters.includes(key))
            .reduce((obj, key) => {
                if (filterValue[key]) {
                    obj[key] = filterValue[key];
                }
                return obj;
            }, {});
        if (this.reportRunParams) {
            params[RUN_AFFILIATE_ID_PARAM] = this.reportRunParams.affiliateId;
            params[RUN_CAMPAIGN_ID_PARAM] = this.reportRunParams.campaignId;
            params[RUN_AS_AFFILIATE_PARAM] = this.reportRunParams.asAffiliate;
        }
        this.gridService.storage.saveFilter(params);
        this.recentlyUsed.updateQueryParams(this.reportDefId, 'REPORT', params);

    }

    private removeDateRangeFields(payLoad: any, inputs: Array<ReportUiDataObj>): void {
        inputs.filter(value => value.type === 'dateRange')
            .forEach(value => {
                payLoad[value.field] = null;
                payLoad[value.field + '_list'] = null;
                this.filterForm.controls[value.field + '_list'].setValue('null') ;
            });
    }

    private getFlatInputs(input: Array<ReportUiDataObj>): Array<ReportUiDataObj> {
        return input.reduce((accumulator: Array<ReportUiDataObj>, curValue: ReportUiDataObj) => {
            accumulator.push(curValue);
            if (curValue.sublist) {
                accumulator.push(...this.getFlatInputs(curValue.sublist));
            }
            return accumulator;
        }, []);
    }

    public getFiltersPayload(): Array<{field: string, value?: any}> {
        return this.reportsDataService.getFilterParamsFromPayload(this.getPayload(false));
    }

    boOnFormReady(form: FormGroup): void {
        let rawValue = form.getRawValue();
        for (let key in rawValue) {
            let foundDefaultValue = this.findDefaultValue(key, this.reportView.input);
            if (foundDefaultValue !== undefined) {
                this.initialFormValue[key] = foundDefaultValue;
            }
        }
        this.filterForm = form;
        this.filterFields.forEach(field =>
            this.filterForm.get([field.field]).valueChanges.pipe(
                    takeUntil(this._destroy$$)
                )
                .subscribe(() => this.firstLoadReport = true));
        if (this.coreReport || this.isReloadNeeded) {
            this.submitFilterForm();
        } else {
            this.preloader.hide(this.preloaderConfig);
        }
    }

    private findDefaultValue(fieldName: string, fields: Array<ReportUiDataObj>): any {
        for (let value of fields) {
            if (value.field === fieldName) {
                return value.value;
            } else if (value.sublist) {
                let found = this.findDefaultValue(fieldName, value.sublist);
                if (found !== undefined && found !== null) {
                    return found;
                }
            }
        }
        return undefined;
    }

    onFiltersToggle(): void {
        this.filtersCollapsed = !this.filtersCollapsed;
        this.drawer.toggle();
    }

    private isNewTab(): boolean {
        return document.referrer.length === 0 || window.history.length === 1;
    }

    private reportUrl = (): void => {
        let payLoad = this.getFiltersPayload();
        let filterParams = this.utils.getQueryStringFromArray(payLoad);
        this.applicationPropertiesService.getProperty('application.path.bo')
            .subscribe(url => {
                url = this.obtainURLSlash(url);
                url += `exportReport?report_name=${this.reportName}`;
                if (filterParams) {
                    url = url + '&' + filterParams;
                }
                let data: MxReportUrlDialogData = {
                    reportUrl: url,
                    headerAuth: true
                };
                this.dialog.open(MxReportUrlDialogComponent, {
                    panelClass: ['mx-dialog-panel-class'],
                    width: '40%',
                    data
                });
            });
    }

    private obtainURLSlash(url: string): string {
        if (!url.endsWith('/')) {
            url += '/';
        }
        return url;
    }

    saveConfig(): void {
        const onCustomize = (event: MxFormCustomizerEvent) => {
            const nameValidation = new FieldValidationObj();
            nameValidation.required = true;
            nameValidation.maxLength = 20;

            const typeField = new FieldUiDataComboBoxObj();
            typeField.type = 'dropdown';
            typeField.name = 'type';
            typeField.label = 'Type';
            typeField.validation = new FieldValidationObj();
            typeField.validation.required = true;
            typeField.options = [
                {key: 'filters', value: 'Filters', dependOn: null},
                {key: 'columns', value: 'Columns', dependOn: null},
                {key: 'filters-columns', value: 'Filters and Columns', dependOn: null},
            ];
            const metaData: ObjectMetaData = new ObjectMetaDataBuilder()
                .addField('name', 'textbox', 'Name', nameValidation)
                .addExistingField(typeField)
                .build();
            const boOnFormReady = (form: FormGroup) => {
                const name = form.get('name');
                name.setValidators([name.validator,
                    (control: AbstractControl): ValidationErrors | null => {
                        if (this.userConfigs.map(value => value.name)
                            .findIndex(value => value === control.value) > -1) {
                            return {'Name not unique': true};
                        }
                        return null;
                    }
                ]);
            };
            event
                .customizeFieldsDataConfig({
                    metaObject: metaData
                })
                .customizeActions({
                    submit: {
                        visible: true,
                        text: 'Save'
                    }
                })
                .addCustomizer({
                    boOnFormReady
                })
                .customizeProps({
                    showNavigation: false,
                    returnResponseAfterSaveInDialog: false,
                    closeOnSubmit: true
                });
        };
        this.dialog.open(MxObjectFormComponent, {
            panelClass: ['mx-dialog-panel-class', 'mx-save-config-dialog'],
            data: {
                title: 'Save User Configuration',
                onCustomize
            }
        }).afterClosed().subscribe(value => this.saveUserConfig(value));
    }

    private saveUserConfig(config: {name: string, type: 'filters' | 'columns'| 'filters-columns'}): void {
        const userConfig: UserConfig = {name: config.name};
        if (config.type === 'filters' || config.type === 'filters-columns') {
            userConfig.filters = this.getPayload(false);
        }
        if (config.type === 'columns' || config.type === 'filters-columns') {
            userConfig.columns = this.gridService.columns.visibleColumns;
        }
        this.userConfigs.push(userConfig);
        const configurationObj: ReportUserConfigurationObj = {
            reportName: this.reportView.name,
            configName: userConfig.name,
            config: JSON.stringify({columns: userConfig.columns, filters: userConfig.filters})
        };
        this.reportsDataService.saveUserConfig(configurationObj);
    }

    private loadReportUserConfig(reportName: string) {
        this.reportsDataService.getUserConfigs(reportName)
            .subscribe(value => {
                this.userConfigs = [];
                value.forEach(item => {
                    const config = JSON.parse(item.config);
                    this.userConfigs.push({name: item.configName, filters: config.filters, columns: config.columns});
                });
            });
    }

    public removeReportUserConfig(config: UserConfig) {
        this.userConfigs = this.userConfigs.filter(value => value !== config);
        this.reportsDataService.deleteUserConfigs(this.reportView.name, config.name);
    }

    public updateUserConfig(userConfig: UserConfig) {
        if (userConfig.filters) {
            userConfig.filters = this.getPayload(false);
        }
        if (userConfig.columns) {
            userConfig.columns = this.gridService.columns.visibleColumns;
        }
        const configurationObj: ReportUserConfigurationObj = {
            reportName: this.reportView.name,
            configName: userConfig.name,
            config: JSON.stringify({columns: userConfig.columns, filters: userConfig.filters})
        };
        this.reportsDataService.saveUserConfig(configurationObj);
    }

    selectConfig(config: UserConfig) {
        if (config.columns) {
            this.gridService.columns.updateColumns(config.columns);
        }
        if (config.filters) {
            this.resetFilterForm();
            this.filterForm.patchValue(config.filters);
        }

    }
}

export interface UserConfig {
    name: string;
    filters?: any;
    columns?: any;
}
